/* eslint-disable class-methods-use-this */
export default class HandleToggle {
  constructor(elements) {
    this.triggers = elements;
    this.setDOMReferences();

    // eslint-disable-next-line prefer-arrow-callback
    document.body.addEventListener('makeTogglePassive', (event) => {
      this.update(event.detail.toggleId, 'passive');
    });
  }

  setDOMReferences() {
    for (let i = 0; i < this.triggers.length; i++) {
      const element = this.triggers[i];
      element.addEventListener('click', () => {
        const id = element.dataset.toggleId;
        let { state } = element.dataset;
        state = state === 'passive' ? 'active' : 'passive';
        this.update(id, state);
      });
    }
  }

  update(id, state) {
    const elements = document.querySelectorAll(`[data-toggle-id=${id}]`);

    // Store previous state for menu toggle to detect closing
    let previousState = null;
    if (id === 'menu-toggle') {
      const firstElement = elements[0];
      if (firstElement) {
        previousState = firstElement.getAttribute('data-state');
      }
    }

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      element.setAttribute('data-state', state);
    }

    // Prevent body scrolling when menu is active
    if (id === 'menu-toggle') {
      if (state === 'active') {
        // Calculate scrollbar width to prevent page jump
        const scrollbarWidth =
          window.innerWidth - document.documentElement.clientWidth;

        // Store current scroll position
        const scrollY = window.scrollY;
        document.body.classList.add('menu-open');

        // Add scrolled class if user is scrolled
        if (scrollY > 0) {
          document.body.classList.add('scrolled');
        } else {
          document.body.classList.remove('scrolled');
        }

        // Calculate the correct top position accounting for sticky header
        const header = document.querySelector('.header');
        let topOffset = scrollY;

        if (header && scrollY > 0) {
          // When scrolled, the header gets top: -116px, so we need to account for this
          const headerHeight = header.getBoundingClientRect().height;
          topOffset = scrollY - 116; // Account for the -116px offset applied to header
        }

        // Set the top position to maintain scroll position
        document.body.style.top = `-${topOffset}px`;

        // Compensate for scrollbar width to prevent page jump
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;

          // Also compensate for the header to prevent sticky menu bar jump
          const header = document.querySelector('.header');
          if (header) {
            header.style.paddingRight = `${scrollbarWidth}px`;
          }
        }
      } else if (state === 'passive' && previousState === 'active') {
        // Only restore scroll position when menu is actually being closed (active -> passive)
        const scrollY = document.body.style.top;
        document.body.classList.remove('menu-open');
        document.body.style.top = '';
        document.body.style.paddingRight = '';

        // Clear header padding as well
        const header = document.querySelector('.header');
        if (header) {
          header.style.paddingRight = '';
        }

        // Calculate the correct scroll position accounting for sticky header
        let scrollPosition = parseInt(scrollY || '0') * -1;

        if (header && scrollPosition > 0) {
          // When scrolled, we need to add back the 116px offset that was subtracted
          scrollPosition += 116;
        }

        window.scrollTo({
          top: scrollPosition,
          behavior: 'instant'
        });
      }
    }
  }
}
